(function () {
  'use strict';
  var CARD_VARIANT_ID = 47692607750315;
  var WRAP_VARIANT_ID = 47692607783083;
  var EXTRA_WRAP_VARIANT_ID = 47701244346539;
  var CHRISTMAS_VARIANT_ID = 48364284313771, PAPER_VARIANT_ID = 48364284674219;
  var running = false;
  var removing = false;
  var rerunTimer = null;
  var rerunPending = false;
  var queuedCart = null;
  var displayRevision = 0;
  // Conceal only ungrouped gift rows while waiting for cart data. Ordinary rows stay visible.
  // Each row has a bounded fallback and is concealed at most once per DOM insertion.
  var preparingRows = new Map();
  var preparedRows = new WeakSet();
  function releasePreparingRows() {
    preparingRows.forEach(function (timer, row) {
      clearTimeout(timer);
      row.classList.remove('th-gift-row-preparing');
    });
    preparingRows.clear();
  }
  function prepareGiftRows() {
    var root = document.getElementById('cart-items');
    if (!root) return;
    if (!document.getElementById('th-gift-cart-preparing-styles')) {
      var style = document.createElement('style');
      style.id = 'th-gift-cart-preparing-styles';
      style.textContent = '#cart-items .th-gift-row-preparing{visibility:hidden!important;}';
      document.head.appendChild(style);
    }
    root.querySelectorAll('.cart-item').forEach(function (row) {
      if (preparedRows.has(row) || row.hasAttribute('data-th-gift-display') ||
        row.classList.contains('th-gift-summary-row')) return;
      var labels = Array.prototype.map.call(row.querySelectorAll('.cart-item__variants dt'), function (dt) {
        return dt.textContent.replace(':', '').trim().toLowerCase();
      });
      var service = [CARD_VARIANT_ID, WRAP_VARIANT_ID, EXTRA_WRAP_VARIANT_ID, CHRISTMAS_VARIANT_ID, PAPER_VARIANT_ID].indexOf(
        Number(row.getAttribute('data-variant-id'))) !== -1;
      if (labels.indexOf('part of gift for') === -1 &&
        !(service && (labels.indexOf('recipient') !== -1 || labels.indexOf('gift service') !== -1))) return;
      preparedRows.add(row);
      row.classList.add('th-gift-row-preparing');
      preparingRows.set(row, setTimeout(function () {
        row.classList.remove('th-gift-row-preparing');
        preparingRows.delete(row);
      }, 3000));
    });
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }
  function escapeHTML(value) {
    var div = document.createElement('div');
    div.textContent =
      value == null ? '' : String(value);
    return div.innerHTML;
  }
  function capitaliseFirst(value) {
    value = String(value || '').trim();
    if (!value) {
      return '';
    }
    return value.charAt(0).toUpperCase() +
      value.slice(1);
  }
  function getGiftReference(item) {
    if (!item || !item.properties) {
      return '';
    }
    return item.properties['_Gift reference'] || '';
  }
  function getProperty(item, name) {
    if (!item || !item.properties) {
      return '';
    }
    return item.properties[name] || '';
  }
  /*
   * OLD + NEW PROPERTY COMPATIBILITY
   */
  function getRecipient(item) {
    return (
      getProperty(item, 'Recipient') ||
      getProperty(item, '_Recipient') ||
      getProperty(item, '_Gift for') ||
      getProperty(item, 'Gift for') ||
      ''
    );
  }
  function getServiceName(item) {
    return (
      getProperty(item, '_Service') ||
      getProperty(item, 'Service') ||
      getProperty(item, 'Gift service') ||
      ''
    );
  }
  function getCardMessage(item) {
    return (
      getProperty(item, 'Christmas tag message') ||
      getProperty(item, 'Card message') ||
      getProperty(item, 'Personalised card') ||
      ''
    );
  }
  function isBlendCarrier(item) { return item.properties && item.properties._byo_carrier === 'true' || Number(item.variant_id || item.id) === 45956039901355; }
  function isGiftService(item) {
    var id = Number(item.variant_id);
    return (
      id === CARD_VARIANT_ID ||
      id === WRAP_VARIANT_ID ||
      id === EXTRA_WRAP_VARIANT_ID || id === CHRISTMAS_VARIANT_ID || id === PAPER_VARIANT_ID
    );
  }
  function isMainGiftService(item) {
    var id = Number(item.variant_id);
    return (
      id === CARD_VARIANT_ID ||
      id === WRAP_VARIANT_ID || id === CHRISTMAS_VARIANT_ID
    );
  }
  function getCart() {
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Could not read cart.'
        );
      }
      return response.json();
    });
  }
  function groupGiftItems(cart) {
    var groups = {};
    cart.items.forEach(function (item) {
      var reference =
        getGiftReference(item);
      if (!reference) {
        return;
      }
      if (!groups[reference]) {
        groups[reference] = {
          reference: reference,
          items: [],
          products: [],
          serviceItems: [],
          carriers: [],
          mainService: null,
          recipient: '',
          serviceName: '',
          message: '',
          physicalQuantity: 0,
          serviceTotal: 0
        };
      }
      var group =
        groups[reference];
      group.items.push(item);
      if (isBlendCarrier(item)) { group.carriers.push(item); return; }
      if (isGiftService(item)) {
        group.serviceItems.push(item);
        group.serviceTotal += Number(
          item.final_line_price || 0
        );
        if (isMainGiftService(item)) {
          group.mainService =
            item;
          group.recipient =
            getRecipient(item) ||
            group.recipient;
          group.serviceName =
            getServiceName(item) ||
            group.serviceName;
          group.message =
            getCardMessage(item) ||
            group.message;
        }
      } else {
        group.products.push(item);
        group.physicalQuantity += Number(
          item.quantity || 0
        );
        if (!group.recipient) {
          group.recipient =
            getRecipient(item);
        }
      }
    });
    return groups;
  }
  function findRowsForCartItems(root, cart) {
    var rows =
      Array.prototype.slice.call(
        root.querySelectorAll('.cart-item')
      );
    // Preserve source order for duplicate variants after visual sorting; never change native line indexes.
    rows.forEach(function(row,index){if(!row.hasAttribute('data-th-source-order')) row.setAttribute('data-th-source-order',String(index));});
    rows.sort(function(a,b){return Number(a.getAttribute('data-th-source-order'))-Number(b.getAttribute('data-th-source-order'));});
    var usedRows = [];
    var matches = [];
    cart.items.forEach(function (item) {
      var matchingRow = item.key ? rows.find(function(row){return usedRows.indexOf(row)===-1 && row.getAttribute('data-th-cart-key')===item.key;}) || null : null;
      for (
        var i = 0;
        i < rows.length;
        i += 1
      ) {
        if (
          matchingRow || usedRows.indexOf(rows[i]) !== -1 || (item.key && rows[i].getAttribute('data-th-cart-key') && cart.items.some(function(line){return line.key===rows[i].getAttribute('data-th-cart-key');}))
        ) {
          continue;
        }
        var rowVariantId =
          Number(
            rows[i].getAttribute(
              'data-variant-id'
            )
          );
        if (
          rowVariantId ===
          Number(item.variant_id)
        ) {
          matchingRow =
            rows[i];
          break;
        }
      }
      if (matchingRow) {
        if(item.key) matchingRow.setAttribute('data-th-cart-key',item.key);
        usedRows.push(
          matchingRow
        );
        matches.push({
          item: item,
          row: matchingRow
        });
      }
    });
    return matches;
  }
  function getRowForItem(
    matches,
    item
  ) {
    for (
      var i = 0;
      i < matches.length;
      i += 1
    ) {
      if (
        matches[i].item === item
      ) {
        return matches[i].row;
      }
    }
    return null;
  }
  function resetDisplay(root) {
    root
      .querySelectorAll(
        '.th-gift-summary-row'
      )
      .forEach(function (element) {
        element.remove();
      });
    root
      .querySelectorAll(
        '.th-gift-product-quantity'
      )
      .forEach(function (element) {
        element.remove();
      });
    root
      .querySelectorAll(
        '.cart-item[data-th-gift-display]'
      )
      .forEach(function (row) {
        row.style.display = '';
        row.removeAttribute(
          'data-th-gift-display'
        );
        row.classList.remove(
          'th-gift-product-row',
          'th-gift-service-row'
        );
        var variants =
          row.querySelector(
            '.cart-item__variants'
          );
        if (variants) {
          var propertyRows =
            variants.querySelectorAll(
              'dl > div'
            );
          propertyRows.forEach(
            function (propertyRow) {
              propertyRow.style.display =
                '';
            }
          );
        }
        var quantity =
          row.querySelector(
            '.cart-item__qty'
          );
        if (quantity) {
          quantity.style.display =
            '';
        }
      });
  }
  function buildGiftSummary(group) {
    var tr =
      document.createElement('tr');
    tr.className =
      'th-gift-summary-row cart-item grid gap-x-8';
    tr.setAttribute(
      'data-th-gift-reference',
      group.reference
    );
    var recipient =
      capitaliseFirst(
        group.recipient ||
        ''
      );
    var serviceName =
      group.serviceName ||
      'Gift service';
    var physicalQuantity =
      group.physicalQuantity;
    var serviceTotal =
      group.serviceTotal;
    var serviceDescription =
      '';
    if (
      group.mainService &&
      Number(
        group.mainService.variant_id
      ) === WRAP_VARIANT_ID
    ) {
      serviceDescription =
        physicalQuantity +
        (
          physicalQuantity === 1
            ? ' item'
            : ' items'
        ) +
        ' included in this gift';
    } else {
      serviceDescription =
        'Personalised card included';
    }
    if (group.mainService && Number(group.mainService.variant_id) === CHRISTMAS_VARIANT_ID) {
      var hasPaper=group.serviceItems.some(function(item){return Number(item.variant_id) === PAPER_VARIANT_ID;});
      var sampleBundles=group.products.reduce(function(total,item) {
        return total + (Number(item.variant_id || item.id) === 17918422855 ? Number(item.quantity) : 0);
      },0);
      if (sampleBundles === physicalQuantity) {
        serviceName=hasPaper ? 'Christmas presentation + festive paper' : 'Christmas presentation';
        serviceDescription=sampleBundles + (sampleBundles === 1 ? ' complete Sample Pack bundle' : ' complete Sample Pack bundles');
      } else {
        serviceName=hasPaper ? 'Christmas presentation + festive paper' : 'Christmas presentation';
        serviceDescription=physicalQuantity + ' products in this gift';
      }

    }
    var chargeBreakdown='';
    if (group.mainService && Number(group.mainService.variant_id) === CHRISTMAS_VARIANT_ID) {
      var presentationTotal=group.serviceItems.filter(function(item){return Number(item.variant_id)===CHRISTMAS_VARIANT_ID;}).reduce(function(total,item){return total+Number(item.final_line_price ?? item.line_price ?? Number(item.price || 500)*Number(item.quantity));},0);
      var paperTotal=group.serviceItems.filter(function(item){return Number(item.variant_id)===PAPER_VARIANT_ID;}).reduce(function(total,item){return total+Number(item.final_line_price ?? item.line_price ?? Number(item.price || 200)*Number(item.quantity));},0);
      var unit=sampleBundles===physicalQuantity ? (physicalQuantity===1 ? 'bundle' : 'bundles') : (physicalQuantity===1 ? 'product' : 'products');
      chargeBreakdown='<dl class="th-gift-charge-breakdown"><div class="th-gift-charge-row"><dt>Christmas presentation <span>' + physicalQuantity + ' ' + unit + (presentationTotal===physicalQuantity*500 ? ' × $5' : '') + '</span></dt><dd>' + money(presentationTotal) + '</dd></div>' + (hasPaper ? '<div class="th-gift-charge-row"><dt>Festive Christmas paper <span>One wrap around the whole gift</span></dt><dd>' + money(paperTotal) + '</dd></div>' : '') + '<div class="th-gift-charge-row th-gift-charge-total"><dt>Total gifting charges</dt><dd>' + money(serviceTotal) + '</dd></div></dl>';
    }
    var messageHTML =
      '';
    if (group.message) {
      messageHTML =
        '<div class="th-gift-display-message">' +
          '<strong>' + (group.mainService && Number(group.mainService.variant_id) === CHRISTMAS_VARIANT_ID ? 'Christmas tag message' : 'Card message') + '</strong>' +
          '<div>' +
            escapeHTML(
              group.message
            ) +
          '</div>' +
        '</div>';
    }
    tr.innerHTML =
      '<td class="th-gift-display-card" colspan="4">' +
        '<div class="th-gift-display-heading">' +
          '<span class="th-gift-display-icon" aria-hidden="true">' +
            '🎁' +
          '</span>' +
          '<div>' +
            '<div class="th-gift-display-label">' +
              'GIFT' +
            '</div>' +
            '<div class="th-gift-display-title">' +
              (recipient ? 'Gift for ' : 'Gift') +
              escapeHTML(
                recipient
              ) +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="th-gift-display-service">' +
          '<div>' +
            '<strong>' +
              escapeHTML(
                serviceName
              ) +
            '</strong>' +
            '<span>' +
              escapeHTML(
                serviceDescription
              ) +
            '</span>' +
          '</div>' +
          (chargeBreakdown ? '' : '<strong class="th-gift-display-price">' + money(serviceTotal) + '</strong>') +
        '</div>' +
        chargeBreakdown +
        messageHTML +
        '<div class="th-gift-display-footer">' +
          '<a class="th-edit-gift-link" href="' +
            escapeHTML(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
              'products/personalised-dried-fruit-gifts?th-edit-gift=' + encodeURIComponent(group.reference)) +
          '">Edit gift / recipient name</a>' +
          '<div class="th-gift-display-note">' +
            'The products below are included in this gift.' +
          '</div>' +
          '<button type="button" ' +
            'class="th-remove-gift" ' +
            'data-gift-reference="' +
            escapeHTML(
              group.reference
            ) +
            '">' +
            'Remove gift' +
          '</button>' +
        '</div>' +
      '</td>';
    return tr;
  }
  /*
   * Cleans the customer-facing gift product row
   * and adds a clear, non-editable quantity label.
   */
  function cleanProductRow(row, item) {
    if (!row) {
      return;
    }
    row.setAttribute(
      'data-th-gift-display',
      'product'
    );
    row.classList.add(
      'th-gift-product-row'
    );
    var oldQuantityLabel =
      row.querySelector(
        '.th-gift-product-quantity'
      );
    if (oldQuantityLabel) {
      oldQuantityLabel.remove();
    }
    var variants =
      row.querySelector(
        '.cart-item__variants'
      );
    if (variants) {
      var propertyRows =
        variants.querySelectorAll(
          'dl > div'
        );
      propertyRows.forEach(
        function (propertyRow) {
          var dt =
            propertyRow.querySelector(
              'dt'
            );
          if (!dt) {
            return;
          }
          var label =
            dt.textContent
              .replace(':', '')
              .trim()
              .toLowerCase();
          if (
            label === 'gift preparation' ||
            label === 'preparation instructions' ||
            label === 'part of gift for' ||
            label === 'gift summary' ||
            label === 'gift includes' ||
            label === 'gift option' ||
            label === 'gift service' ||
            label === 'gift' ||
            label === '_gift' ||
            label === 'gift quantity' ||
            label === '_gift quantity' ||
            label === 'gift for' ||
            label === '_gift for' ||
            label === 'recipient' ||
            label === '_recipient' ||
            label === 'service' ||
            label === '_service' ||
            label === 'gift contains' ||
            label === '_gift contains' ||
            label === 'card message' ||
            label === 'for gift' ||
            label === '_for gift' ||
            label === 'wrapping for' ||
            label === '_wrapping for'
          ) {
            propertyRow.style.display =
              'none';
          }
        }
      );
      if (item) {
        var quantityLabel =
          document.createElement('div');
        quantityLabel.className =
          'th-gift-product-quantity';
        quantityLabel.innerHTML =
          '<strong>Qty:</strong> ' +
          escapeHTML(
            String(item.quantity || 1)
          );
        variants.appendChild(
          quantityLabel
        );
      }
    }
    /*
     * Keep the normal Shopify quantity controls
     * hidden for gift products. Changing quantities
     * here would break the gift-wrapping calculation.
     */
    var quantity =
      row.querySelector(
        '.cart-item__qty'
      );
    if (quantity) {
      quantity.style.display =
        'none';
    }
  }
  function hideServiceRow(row) {
    if (!row) {
      return;
    }
    row.setAttribute(
      'data-th-gift-display',
      'service'
    );
    row.classList.add(
      'th-gift-service-row'
    );
    row.style.display =
      'none';
  }
  function removeGift(reference, button) {
    if (removing) return;
    if (!window.confirm("Remove this entire personalised gift, including its products and any gifting charges? Other cart items will stay unchanged.")) return;
    removing = true; button.disabled = true; button.textContent = 'Removing gift...';
    Promise.resolve().then(function () {
      if (!window.THGiftCart || !window.THGiftCart.remove) throw new Error('Gift protection is still loading. Please reload the cart.');
      return window.THGiftCart.remove(reference);
    }).then(function () { window.location.reload(); }).catch(function (error) {
      removing = false; button.disabled = false; button.textContent = 'Remove gift';
      window.alert(error.message || 'Please review your gift in the cart.');
    });
  }
  function addStyles() {
    if (
      document.getElementById(
        'th-gift-cart-display-styles'
      )
    ) {
      return;
    }
    var style =
      document.createElement(
        'style'
      );
    style.id =
      'th-gift-cart-display-styles';
    style.textContent =
      '.th-gift-summary-row{' +
        'display:table-row;' +
      '}' +
      '.th-gift-display-card{' +
        'grid-column:1/-1;' +
        'width:100%;' +
        'padding:18px 20px!important;' +
        'margin:0 0 4px;' +
        'border:1px solid #d5e5cf;' +
        'border-radius:10px;' +
        'background:#f8fbf6;' +
        'box-sizing:border-box;' +
      '}' +
      '.th-gift-display-heading{' +
        'display:flex;' +
        'align-items:center;' +
        'gap:11px;' +
        'margin-bottom:14px;' +
      '}' +
      '.th-gift-display-icon{' +
        'display:flex;' +
        'align-items:center;' +
        'justify-content:center;' +
        'width:38px;' +
        'height:38px;' +
        'border-radius:50%;' +
        'background:#eef6e9;' +
        'font-size:19px;' +
      '}' +
      '.th-gift-display-label{' +
        'margin-bottom:1px;' +
        'color:#285b32;' +
        'font-size:10px;' +
        'font-weight:800;' +
        'letter-spacing:.14em;' +
      '}' +
      '.th-gift-display-title{' +
        'color:#285b32;' +
        'font-size:20px;' +
        'font-weight:800;' +
        'line-height:1.2;' +
      '}' +
      '.th-gift-display-service{' +
        'display:flex;' +
        'align-items:flex-start;' +
        'justify-content:space-between;' +
        'gap:18px;' +
        'padding:12px 0;' +
        'border-top:1px solid #dce6d8;' +
        'border-bottom:1px solid #dce6d8;' +
      '}' +
      '.th-gift-display-service strong{' +
        'display:block;' +
      '}' +
      '.th-gift-display-service span{' +
        'display:block;' +
        'margin-top:2px;' +
        'font-size:13px;' +
        'opacity:.72;' +
      '}' +
      '.th-gift-display-price{' +
        'white-space:nowrap;' +
        'color:#285b32;' +
      '}' +
      '.th-gift-display-message{' +
        'margin-top:13px;' +
        'padding:11px 13px;' +
        'border-radius:7px;' +
        'background:#fff;' +
        'font-size:13px;' +
        'line-height:1.45;' +
      '}' +
      '.th-gift-display-message strong{' +
        'display:block;' +
        'margin-bottom:3px;' +
        'color:#285b32;' +
      '}' +
      '.th-gift-display-footer .th-edit-gift-link{' +
        'display:inline-flex;' +
        'align-items:center;' +
        'justify-content:center;' +
        'box-sizing:border-box;' +
        'min-height:44px;' +
        'padding:10px 20px;' +
        'border:2px solid #285b32;' +
        'border-radius:6px;' +
        'background:#fff;' +
        'color:#285b32;' +
        'font:inherit;' +
        'font-size:15px;' +
        'font-weight:700;' +
        'line-height:1.3;' +
        'text-decoration:none;' +
        'white-space:nowrap;' +
        'cursor:pointer;' +
      '}' +
      '.th-gift-display-footer .th-edit-gift-link:hover{' +
        'background:#eef6e9;' +
        'color:#285b32;' +
        'text-decoration:none;' +
      '}' +
      '.th-gift-display-footer .th-edit-gift-link:focus-visible{' +
        'outline:3px solid #285b32;' +
        'outline-offset:3px;' +
      '}' +
      '.th-gift-display-footer{' +
        'flex-wrap:wrap;' +
        'display:flex;' +
        'align-items:center;' +
        'justify-content:space-between;' +
        'gap:16px;' +
        'margin-top:12px;' +
      '}' +
      '.th-gift-display-note{' +
        'font-size:12px;' +
        'opacity:.68;' +
      '}' +
      '.th-remove-gift{' +
        'appearance:none;' +
        'border:0;' +
        'padding:0;' +
        'background:transparent;' +
        'color:#6b4038;' +
        'font:inherit;' +
        'font-size:12px;' +
        'font-weight:700;' +
        'text-decoration:underline;' +
        'text-underline-offset:2px;' +
        'cursor:pointer;' +
        'white-space:nowrap;' +
      '}' +
      '.th-remove-gift:hover{' +
        'color:#3f2520;' +
      '}' +
      '.th-remove-gift:disabled{' +
        'opacity:.55;' +
        'cursor:wait;' +
      '}' +
      '.th-gift-product-row{' +
        'position:relative;' +
        'background:#fcfdfb;' +
        'border-left:3px solid #a8cf98;' +
        'padding-left:12px;' +
      '}' +
      '.th-gift-product-quantity{' +
        'margin-top:4px;' +
        'font-size:13px;' +
        'line-height:1.4;' +
        'color:inherit;' +
      '}' +
      '.th-gift-product-quantity strong{' +
        'font-weight:700;' +
      '}' +
      '@media(max-width:749px){' +
        '.th-gift-display-card{' +
          'padding:15px!important;' +
        '}' +
        '.th-gift-display-title{' +
          'font-size:18px;' +
        '}' +
        '.th-gift-display-service{' +
          'gap:10px;' +
        '}' +
        '.th-gift-display-footer{' +
          'align-items:flex-start;' +
          'flex-direction:column;' +
          'gap:8px;' +
        '}' +
        '.th-gift-product-row{' +
          'padding-left:8px;' +
        '}' +
      '}';
    style.textContent += ".th-gift-charge-breakdown{margin:14px 0 16px;padding:14px 16px;border:1px solid #d5e5cf;border-radius:8px;background:#fff;font-size:14px;line-height:1.4}.th-gift-charge-row{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:start;gap:12px;padding:8px 0}.th-gift-charge-row dt{margin:0;font-weight:650}.th-gift-charge-row dt span{display:block;margin-top:3px;font-size:12px;font-weight:400;color:#555}.th-gift-charge-row dd{margin:0;white-space:nowrap;font-weight:700;font-variant-numeric:tabular-nums}.th-gift-charge-total{margin-top:6px;padding-top:12px;border-top:1px solid #d5e5cf;color:#285b32;font-size:15px}.th-gift-display-footer{gap:12px!important}.th-gift-display-note{display:none}.th-gift-charge-breakdown+.th-gift-display-footer{margin-top:14px}@media(max-width:600px){.th-gift-charge-breakdown{padding:10px 12px}.th-gift-charge-row{gap:10px}.th-gift-display-footer{align-items:stretch!important}.th-gift-display-footer .th-edit-gift-link{text-align:center}.th-standard-gift-button{min-height:44px}}";
    style.textContent += ".th-cart-category-row td{padding:22px 0 10px!important;font-size:16px;font-weight:750;color:#285b32;border-bottom:1px solid #d5e5cf}.th-cart-category-row:first-child td{padding-top:8px!important}";
    document.head.appendChild(
      style
    );
  }
  function isStandaloneChristmas(item) {
    return Boolean(getProperty(item,'_Christmas Gift ID') || getProperty(item,'Christmas Gift Reference') || /christmas-dried-fruit-gift-packs/.test(item.handle || item.url || ''));
  }
  function sortCartGroups(root,cart,matches) {
    root.querySelectorAll('.th-cart-category-row').forEach(function(row){row.remove();});
    var cartForm=root.closest('form') || root.querySelector('form');
    if(cartForm){
      cartForm.thGiftOrderedFields=cart.items.map(function(item){return {item:item,row:getRowForItem(matches,item)};});
      if(!cartForm.thGiftFormDataBound){
        cartForm.thGiftFormDataBound=true;
        cartForm.addEventListener('formdata',function(event){
          // Sorting is visual only. Native /cart form arrays must retain Shopify line order.
          if(!event.formData || !event.formData.has('updates[]')) return;
          event.formData.delete('updates[]');
          cartForm.thGiftOrderedFields.forEach(function(entry){
            var input=entry.row && entry.row.querySelector('[name="updates[]"]');
            event.formData.append('updates[]',input ? input.value : String(entry.item.quantity));
          });
        });
      }
    }
    var refOrder=[], blocks=[];
    matches.forEach(function(match,index){
      var item=match.item,ref=getGiftReference(item),marked=String(getProperty(item,'_Gift') || getProperty(item,'Gift')).toLowerCase()==='yes';
      var category=isStandaloneChristmas(item)?1:(ref || marked || isGiftService(item)?2:0);
      if(ref && refOrder.indexOf(ref)===-1) refOrder.push(ref);
      blocks.push({row:match.row,item:item,category:category,group:ref?refOrder.indexOf(ref):refOrder.length,index:index});
    });
    blocks.sort(function(a,b){return a.category-b.category || (a.category===2?a.group-b.group:0) || a.index-b.index;});
    var parents=[];
    blocks.forEach(function(block){if(parents.indexOf(block.row.parentNode)===-1)parents.push(block.row.parentNode);});
    parents.forEach(function(parent){
      var last=-1;
      blocks.filter(function(block){return block.row.parentNode===parent;}).forEach(function(block){
        if(block.category!==last){
          var heading=document.createElement('tr');heading.className='th-cart-category-row';
          heading.setAttribute('data-th-cart-category',String(block.category));
          var cell=document.createElement('td');cell.colSpan=4;
          cell.textContent=['Standard products — no gifting','Ready-made Christmas Gift Packs','Personalised gifts'][block.category];
          heading.appendChild(cell);parent.appendChild(heading);last=block.category;
        }
        parent.appendChild(block.row);
      });
    });
  }
  function renderGiftDisplay(cart) {
    var root =
      document.getElementById(
        'cart-items'
      );
    if (!root) {
      return;
    }
    resetDisplay(root);
    addStyles();
    var groups =
      groupGiftItems(cart);
    var matches =
      findRowsForCartItems(
        root,
        cart
      );
    sortCartGroups(root,cart,matches);
    root.querySelectorAll('.th-preparation-label').forEach(function(label){ label.remove(); });
    cart.items.forEach(function(item){
      if (isGiftService(item) || isBlendCarrier(item) || getGiftReference(item)) return;
      var row=getRowForItem(matches,item);
      if (!row) return;
      var p=item.properties || {};
      var christmas=isStandaloneChristmas(item);
      // An orphaned legacy gift must never be labelled as ordinary packaging.
      var marked=String(p._Gift || p.Gift || '').toLowerCase()==='yes';
      var label=document.createElement('div');label.className='th-preparation-label';
      label.style.cssText='font-weight:700;margin:8px 0;font-size:13px';
      label.textContent=christmas?'CHRISTMAS GIFT — individual complete gift':marked?'GIFT — please review gifting details':'STANDARD PACKAGING — no gifting';
      var target=row.querySelector('.cart-item__details') || row.querySelector('td');
      if(target) target.appendChild(label);
    });
    Object.keys(groups).forEach(
      function (reference) {
        var group =
          groups[reference];
        if (
          !group.products.length ||
          !group.mainService
        ) {
          return;
        }
        var firstProductRow =
          getRowForItem(
            matches,
            group.products[0]
          );
        if (!firstProductRow) {
          return;
        }
        group.carriers.forEach(function(item) { hideServiceRow(getRowForItem(matches,item)); });
        group.serviceItems.forEach(
          function (serviceItem) {
            hideServiceRow(
              getRowForItem(
                matches,
                serviceItem
              )
            );
          }
        );
        group.products.forEach(
          function (productItem) {
            cleanProductRow(
              getRowForItem(
                matches,
                productItem
              ),
              productItem
            );
          }
        );
        var summary =
          buildGiftSummary(
            group
          );
        firstProductRow.parentNode
          .insertBefore(
            summary,
            firstProductRow
          );
      }
    );
  }
  // Only used by the Stage 1 “Review my existing gift” navigation.
  var focusedGiftReviewHash = null;
  function focusRequestedGiftSummary() {
    var hash = window.location.hash || '';
    if (hash !== '#th-gift-review' && hash.indexOf('#th-gift-review=') !== 0) return;
    if (focusedGiftReviewHash === hash) return;
    var reference = '';
    if (hash.indexOf('=') !== -1) {
      try { reference = decodeURIComponent(hash.slice(hash.indexOf('=') + 1)); }
      catch (error) { return; }
    }
    var root = document.getElementById('cart-items');
    if (!root) return;
    var summaries = root.querySelectorAll('.th-gift-summary-row');
    for (var i = 0; i < summaries.length; i += 1) {
      if (!reference || summaries[i].getAttribute('data-th-gift-reference') === reference) {
        summaries[i].setAttribute('tabindex', '-1');
        summaries[i].focus({preventScroll: true});
        summaries[i].scrollIntoView({behavior: 'smooth', block: 'center'});
        focusedGiftReviewHash = hash;
        return;
      }
    }
  }
  window.addEventListener('hashchange', function () {
    focusedGiftReviewHash = null;
    focusRequestedGiftSummary();
  });
  function run() {
    clearTimeout(rerunTimer);
    rerunTimer = null;
    if (removing) return;
    if (running) { rerunPending = true; return; }
    if (!document.getElementById('cart-items')) return;
    running = true;
    rerunPending = false;
    var revision = displayRevision;
    var cart = queuedCart;
    queuedCart = null;
    var request = cart ? Promise.resolve(cart) : getCart();
    request.then(function (freshCart) {
      // A newer cart update must be rendered instead of this older response.
      if (revision !== displayRevision || removing) return;
      observer.disconnect();
      try {
        renderGiftDisplay(freshCart);
        focusRequestedGiftSummary();
      } finally { releasePreparingRows(); startObserver(); }
    }).catch(function (error) {
      releasePreparingRows();
      console.warn('Tropical Harvest gift cart display:', error);
    }).then(function () {
      running = false;
      if (rerunPending && !removing) run();
    });
  }
  function scheduleRun() {
    prepareGiftRows();
    displayRevision += 1;
    queuedCart = null;
    rerunPending = true;
    clearTimeout(rerunTimer);
    rerunTimer = setTimeout(run, 80);
  }
  // Reuse the authoritative cart returned by completed shared gift operations.
  window.addEventListener('th-gift-cart-state', function (event) {
    var cart = event.detail;
    if (!cart || !Array.isArray(cart.items)) return;
    displayRevision += 1;
    queuedCart = cart;
    rerunPending = true;
    run();
  });
  /*
   * Handle Remove gift using event delegation,
   * because the gift summary is created dynamically.
   */
  document.addEventListener(
    'click',
    function (event) {
      var button =
        event.target.closest(
          '.th-remove-gift'
        );
      if (!button) {
        return;
      }
      event.preventDefault();
      var reference =
        button.getAttribute(
          'data-gift-reference'
        );
      if (!reference) {
        return;
      }
      removeGift(
        reference,
        button
      );
    }
  );
  var observer =
    new MutationObserver(
      function (mutations) {
        var shouldRun =
          false;
        mutations.forEach(
          function (mutation) {
            if (
              mutation.addedNodes.length ||
              mutation.removedNodes.length
            ) {
              shouldRun =
                true;
            }
          }
        );
        if (shouldRun) {
          scheduleRun();
        }
      }
    );
  function startObserver() {
    var root =
      document.getElementById(
        'cart-items'
      );
    if (!root) {
      return;
    }
    observer.observe(
      root,
      {
        childList:
          true,
        subtree:
          true
      }
    );
  }
  function initialiseGiftDisplay() {
    prepareGiftRows();
    startObserver();
    run();
  }
  // Start before DOMContentLoaded when the cart markup is already present.
  prepareGiftRows();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseGiftDisplay, {once: true});
  } else {
    initialiseGiftDisplay();
  }
})();